<!-- Assuming your app-header and app-footer components are structured correctly -->

<div class="flex flex-col min-h-screen bg-gradient-to-b " style="
      background: linear-gradient(
        180deg,
        #5C9DFE 0%,
        #5C9DFE 39.94%,
        #8BC9F9 113.79%
      );
    ">>
  <app-header></app-header>
  <div class="flex-1 flex items-center justify-center " style="
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.28) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      ">
    <div class="flex-1 flex items-center justify-center py-4 px-4 sm:px-6 lg:px-8">
      <div class="max-w-4xl w-full mt-16 flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden">
        <!-- SVG Image Section -->
        <div class="hidden md:block w-full md:w-1/2 p-8 bg-gradient-to-br from-white to-gray-300 relative">
          <img src="assets/images/register-org/login-auth-in-blue-theme.svg" alt="Login Image" class="w-full h-full object-contain">
          <div class="absolute top-0 left-0 p-4">
            <img class="w-16" src="assets/images/logo/orbit-full-logo.png" alt="logo" (click)="goTo('/')"/>
          </div>
        </div>

        <!-- Form Section -->
        <div class="w-full pt-10 md:w-1/2 flex flex-col">
          <div
            class="p-8 pb-0 flex flex-col items-center justify-center bg-white rounded-t-lg md:rounded-t-none md:rounded-l-lg">
            <!--<div class="fill-current text-center">
              <img class="w-24 mb-4" src="assets/img/logo/logo.png" alt="logo">
            </div>-->
            <div
              class="rounded-full mb-2 h-16 w-16 flex items-center justify-center text-primary-600 bg-primary-600/10" *ngIf="pageExtras['buttonType'] === 'login'">
              <img
                [src]="s3_bucket_url + pageExtras['profileImage']"
                (error)="onImgError($event)"
                class="avatar-image w-full h-full rounded-full shadow-1px-light"
                alt="Avatar"/>
            </div>
            <h2 class="text-3xl font-semibold mb-2" *ngIf="formType === 'login'" [style.font-family]="'var(--vex-font)'">Welcome Back!</h2>
            <h2 class="text-3xl font-semibold mb-2" *ngIf="formType === 'signIn'" [style.font-family]="'var(--vex-font)'">Join Us!</h2>
            <p class="text-lg text-gray-600" *ngIf="formType === 'login'" [style.font-family]="'var(--vex-font)'">Sign in with your credentials below.</p>
            <p class="text-lg text-gray-600" *ngIf="formType === 'signIn'" [style.font-family]="'var(--vex-font)'">Create your account now.</p>
            <img *ngIf="pageExtras['imageUrl']" [src]="pageExtras['imageUrl']" alt="logo" class="logo-icon">
          </div>
          <form [formGroup]="loginForm" class="p-8 flex flex-col gap-6 bg-white" *ngIf="formType === 'login'">
            <div class="flex flex-col gap-4">
              <mat-form-field appearance="outline">
                <mat-label [style.font-family]="'var(--vex-font)'">Organisation</mat-label>
                <input type="text" placeholder="Your organisation name" matInput formControlName="organisation_name" [style.font-family]="'var(--vex-font)'" [readonly]="pageExtras['buttonType'] === 'login'">
              </mat-form-field>
              <mat-form-field *ngIf="pageExtras['buttonType'] === 'login'" appearance="outline" [hideRequiredMarker]="true">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Username" formControlName="username" required [style.font-family]="'var(--vex-font)'">
                <small class="text-red-500" *ngIf="submitted && loginForm.get('username').hasError('required')">
                  Username is required
                </small>
              </mat-form-field>
              <mat-form-field *ngIf="pageExtras['buttonType'] === 'login'" appearance="outline" [hideRequiredMarker]="true">
                <mat-label>Password</mat-label>
                <input [type]="inputType" formControlName="password" matInput required [style.font-family]="'var(--vex-font)'">
                <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                        type="button" [style.font-family]="'var(--vex-font)'">
                  <mat-icon *ngIf="visible" svgIcon="mat:visibility" [style.font-family]="'var(--vex-font)'"></mat-icon>
                  <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off" [style.font-family]="'var(--vex-font)'"></mat-icon>
                </button>
                <small class="text-red-500" *ngIf="submitted && loginForm.get('password').hasError('required')">
                  Password is required.
                </small>
                <small class="text-red-500" *ngIf="submitted && loginForm.get('password')?.errors?.minlength">
                  Password must be at least {{loginForm.get('password')?.errors?.minlength?.requiredLength}} characters long.
                </small>
              </mat-form-field>
            </div>
            <div class="flex items-center justify-between">
              <mat-checkbox color="primary" [style.font-family]="'var(--vex-font)'">Remember Me</mat-checkbox>
<!--
              <a class="text-blue-500" href="#" [style.font-family]="'var(&#45;&#45;vex-font)'">Forgot Password?</a>
-->
            </div>
            <button *ngIf="pageExtras['buttonType'] === 'login'" (click)="login()" color="primary" mat-raised-button
                    class="w-full py-2 mt-4 bg-blue-500 text-white rounded-lg" [style.font-family]="'var(--vex-font)'">Log In
            </button>
            <button *ngIf="pageExtras['buttonType'] === 'search'" (click)="getUsers()" color="primary" mat-raised-button
                    class="w-full py-2 mt-4 bg-blue-500 text-white rounded-lg" [style.font-family]="'var(--vex-font)'">Search Organisation
            </button>
          
            <p class="text-gray-600 text-center mt-4" [style.font-family]="'var(--vex-font)'">Don't have an account?<br/>
              <a class="text-blue-500 cursor-pointer" (click)="goTo('/auth/register')">
                Create one
              </a>
            </p>
          </form>
          <form [formGroup]="signInForm" class="p-8 flex flex-col gap-6 bg-white" *ngIf="formType === 'signIn'">
            <div class="flex flex-col gap-4">
              <mat-form-field appearance="outline">
                <mat-label>Organisation Name</mat-label>
                <input matInput placeholder="Organisation name" formControlName="organisation_name" required>
                <small class="text-red-500" *ngIf="submitted && signInForm.get('organisation_name').hasError('required')">Organisation
                  name is required</small>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" formControlName="name" required>
                <small class="text-red-500" *ngIf="submitted && signInForm.get('name').hasError('required')">Name is
                  required</small>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email" required>
                <small class="text-red-500" *ngIf="submitted && signInForm.get('email').hasError('required')">Email is
                  required</small>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Contact</mat-label>
                <input matInput placeholder="Contact" formControlName="contact" required>
                <small class="text-red-500" *ngIf="submitted && signInForm.get('contact').hasError('required')">Contact is
                  required</small>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Username" formControlName="username" required>
                <small class="text-red-500" *ngIf="submitted && signInForm.get('username').hasError('required')">Username
                  is required</small>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input [type]="inputType" formControlName="password" matInput required>
                <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                        type="button">
                  <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
                  <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
                </button>
                <small class="text-red-500" *ngIf="submitted && signInForm.get('password').hasError('required')">Password
                  is required</small>
              </mat-form-field>
            </div>
            <button (click)="otp()" color="primary" mat-raised-button
                    class="w-full py-2 mt-4 bg-blue-500 text-white rounded-lg">SIGN UP
            </button>
            <p class="text-gray-600 text-center mt-4">Already have an account?<br/><a class="text-blue-500 cursor-pointer"
                                                                                      (click)="loginFormVisible()">Login
              here</a></p>
          </form>
          <form [formGroup]="otpForm" class="p-8 flex flex-col gap-6 bg-white" *ngIf="formType === 'otpForm'">
            <div class="flex flex-col">
              <mat-form-field appearance="outline">
                <mat-label>Enter OTP</mat-label>
                <input matInput placeholder="OTP" formControlName="otp" required>
                <small class="text-red-500" *ngIf="submitted && otpForm.get('otp').hasError('required')">OTP is
                  required</small>
              </mat-form-field>
            </div>
            <button (click)="signIn()" color="primary" mat-raised-button
                    class="w-full py-2 mt-4 bg-blue-500 text-white rounded-lg" [disabled]="is_submitting">
              <span *ngIf="!is_submitting">SIGN UP</span>
              <span class="loader p-2" *ngIf="is_submitting">Registration in process. Please wait...</span>
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
</div>
<app-footer></app-footer>


<!--<div class="w-full h-full bg-pattern flex flex-col items-center justify-center">
  <div @fadeInUp class="card overflow-hidden w-full max-w-md">
    <div class="p-6 pb-0 flex flex-col items-center justify-center">
      <div class="fill-current text-center">
        <img class="w-16" ngSrc="assets/img/logo/logo.png" height="2331" width="2588" alt="logo">
      </div>
    </div>
    <div class="text-center mt-4">
      <h2 class="title m-0" *ngIf="formType === 'login'">Welcome back</h2>
      <h2 class="title m-0" *ngIf="formType === 'signIn'">Welcome</h2>
      <h4 class="body-2 text-secondary m-0" *ngIf="formType === 'login'">Sign in with your credentials below.</h4>
      <h4 class="body-2 text-secondary m-0" *ngIf="formType === 'signIn'">Sign up here.</h4>
    </div>
    <form [formGroup]="loginForm" class="p-6 flex flex-col gap-4" *ngIf="formType === 'login'">
      <div class="flex flex-col">
        <mat-form-field class="" appearance="outline">
          <mat-label>Organisation</mat-label>
          <input type="text"
                 placeholder="Select your organisation"
                 aria-label="organisation"
                 matInput #organisation
                 (keydown)="showOrganisation(organisation.value)"
                 [formControl]="myControl"
                 [matAutocomplete]="auto">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            @for (organisation of filteredOptions | async; track organisations) {
              <mat-option *ngIf="show_organisation" [value]="organisation.organisation_name">{{organisation?.organisation_name}}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="flex-1 mt-3" appearance="outline">
          <mat-label>Username</mat-label>
          <input matInput placeholder="Username" formControlName="username" required>
          <small class="text-danger text-italic" *ngIf="submitted && loginForm.get('username').hasError('required')">Username
            field is required</small>
        </mat-form-field>
        <mat-form-field class="flex-1 mt-3" appearance="outline">
          <mat-label>Password</mat-label>
          <input [type]="inputType" formControlName="password" matInput required>
          <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
            <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
            <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
          </button>
          <mat-hint>Click the eye to toggle visibility</mat-hint>
          <small class="text-danger text-italic" *ngIf="submitted && loginForm.get('password').hasError('required')">Password
            field is required</small>
        </mat-form-field>
      </div>
      <div class="flex items-center justify-between">
        <mat-checkbox class="caption" color="primary">Remember Me</mat-checkbox>
        <a class="caption">Forgot Password ?</a>
      </div>
      <button (click)="login()" color="primary" mat-raised-button type="button">
        Log In
      </button>
      <p class="text-secondary text-center">
        Don't have an account ?<br />
        <a>Click here to
&lt;!&ndash;          <button class="cursor-pointer text-red-800" (click)="registerFormVisible()"> create</button>&ndash;&gt;
          <button class="cursor-pointer text-red-800" (click)="goTo('register-org')"> create</button>
          one</a>
      </p>
    </form>

    <form [formGroup]="signInForm" class="p-6 flex flex-col gap-4 " *ngIf="formType === 'signIn'">
      <div class="flex flex-col">
        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>Organisation Name</mat-label>
          <input matInput placeholder="Organisation name" formControlName="organisation_name" required>
          <small class="text-danger text-italic"
                 *ngIf="submitted && signInForm.get('organisation_name').hasError('required')">Username field is
            required</small>
        </mat-form-field>
        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput placeholder="Name" formControlName="name" required>
          <small class="text-danger text-italic" *ngIf="submitted && signInForm.get('name').hasError('required')">Username
            field is required</small>
        </mat-form-field>
        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" required>
          <small class="text-danger text-italic" *ngIf="submitted && signInForm.get('email').hasError('required')">Username
            field is required</small>
        </mat-form-field>
        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>Contact</mat-label>
          <input matInput placeholder="Contact" formControlName="contact" required>
          <small class="text-danger text-italic" *ngIf="submitted && signInForm.get('contact').hasError('required')">Username
            field is required</small>
        </mat-form-field>
        <mat-form-field class="flex-1" appearance="outline">
          <mat-label>username</mat-label>
          <input matInput placeholder="Username" formControlName="username" required>
          <small class="text-danger text-italic" *ngIf="submitted && signInForm.get('username').hasError('required')">Username
            field is required</small>
        </mat-form-field>
        <mat-form-field class="flex-1 mt-3" appearance="outline">
          <mat-label>Password</mat-label>
          <input [type]="inputType" formControlName="password" matInput required>
          <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
            <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
            <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
          </button>
          <mat-hint>Click the eye to toggle visibility</mat-hint>
          <small class="text-danger text-italic" *ngIf="submitted && signInForm.get('password').hasError('required')">Password
            field is required</small>
        </mat-form-field>
      </div>
      <button (click)="otp()" color="primary" mat-raised-button type="button">
        SIGN UP
      </button>
      <p class="text-secondary text-center">
        Already have an account ?<br />
        <a>Click here to
          <button class="cursor-pointer text-red-800" (click)="loginFormVisible()"> login</button>
          here</a>
      </p>
    </form>

    <form [formGroup]="otpForm" class="p-6 flex flex-col gap-4" *ngIf="formType === 'otpForm'">
      <div class="flex flex-col">

        <mat-form-field class="flex-1 mt-3" appearance="outline">
          <mat-label>Enter Otp</mat-label>
          <input matInput placeholder="Otp" formControlName="otp" required>
          <small class="text-danger text-italic" *ngIf="submitted && otpForm.get('otp').hasError('required')">Otp field
            is required</small>
        </mat-form-field>
      </div>
      <button (click)="signIn()" color="primary otp-btn" mat-raised-button type="button" [disabled]="is_submitting">
        <span *ngIf="!is_submitting"> SIGN UP</span>
        <span class="loader p-2" *ngIf="is_submitting">Registration in process. Please wait for a while.......</span>
      </button>
    </form>

  </div>
</div>-->
